<div class="start-container">
  <h1 class="enr-title" [innerHTML]="'platform_start_Data1' |i18n"></h1>
  <div class="metrics-container">
    <div class="box">
      <div class="placeholder first"></div>
    </div>
    <div class="box">
      <div class="placeholder second"></div>
    </div>
    <div class="box">
      <div class="placeholder third"></div>
    </div>
  </div>
</div>
